import React from 'react';
import PropTypes from 'prop-types';
import { HTML } from "../../general-widgets/HTML";
import { getParagraphsFromStrings } from "../../../utils/get-paragraphs-from-strings";
import { buildKeyFromStrings } from "../../../utils/build-key-from-strings";
import { Grid } from "../../layout/Grid";
import { GridColumn } from "../../layout/GridColumn";
import { GridRow } from "../../layout/GridRow";
import { Heading } from "../../typography/Heading";
import { Paragraph } from "../../typography/Paragraph";
import { Link } from "../../elements/Link";
import { Modal } from "../../elements/Modal";
import { CANCELLATION_POLICY, DAMAGE_DEPOSIT, NOTES, PAYMENT_SCHEDULE, POLICY_AND_NOTES, VIEW_MORE } from "../../../utils/default-strings";
import { getRuleMarkup } from "./utils/getRuleMarkup";
export var Component = function Component(_ref) {
  var cancellationPolicyHeadingText = _ref.cancellationPolicyHeadingText,
      cancellationPolicyRules = _ref.cancellationPolicyRules,
      damageDepositHeadingText = _ref.damageDepositHeadingText,
      damageDepositRules = _ref.damageDepositRules,
      extraNotesText = _ref.extraNotesText,
      modalTriggerText = _ref.modalTriggerText,
      notesHeadingText = _ref.notesHeadingText,
      notesText = _ref.notesText,
      headingText = _ref.headingText,
      paymentScheduleHeadingText = _ref.paymentScheduleHeadingText,
      paymentScheduleRules = _ref.paymentScheduleRules;
  return React.createElement(Grid, {
    isStackable: true
  }, React.createElement(GridRow, null, React.createElement(GridColumn, {
    width: 12
  }, React.createElement(Heading, null, headingText))), (!!paymentScheduleRules || !!cancellationPolicyRules) && React.createElement(GridRow, null, !!paymentScheduleRules && React.createElement(GridColumn, {
    width: 6
  }, React.createElement(Heading, {
    size: "small"
  }, paymentScheduleHeadingText), paymentScheduleRules.map(getRuleMarkup)), !!cancellationPolicyRules && React.createElement(GridColumn, {
    width: 6
  }, React.createElement(Heading, {
    size: "small"
  }, cancellationPolicyHeadingText), cancellationPolicyRules.map(getRuleMarkup))), !!damageDepositRules && React.createElement(GridRow, null, React.createElement(GridColumn, {
    width: 12
  }, React.createElement(Heading, {
    size: "small"
  }, damageDepositHeadingText), damageDepositRules.map(getRuleMarkup))), !!notesText && React.createElement(GridRow, null, React.createElement(GridColumn, {
    width: 12
  }, React.createElement(Heading, {
    size: "small"
  }, notesHeadingText), React.createElement(HTML, {
    htmlString: notesText
  }))), !!extraNotesText && React.createElement(GridRow, null, React.createElement(GridColumn, {
    width: 12
  }, React.createElement(Modal, {
    hasPadding: true,
    trigger: React.createElement(Link, null, modalTriggerText)
  }, getParagraphsFromStrings(extraNotesText).map(function (paragraphText, index) {
    return React.createElement(Paragraph, {
      key: buildKeyFromStrings(paragraphText, index)
    }, paragraphText);
  })))));
};
Component.displayName = 'PolicyAndNotes';
Component.defaultProps = {
  cancellationPolicyHeadingText: CANCELLATION_POLICY,
  cancellationPolicyRules: null,
  damageDepositHeadingText: DAMAGE_DEPOSIT,
  damageDepositRules: null,
  extraNotesText: null,
  modalTriggerText: VIEW_MORE,
  notesHeadingText: NOTES,
  notesText: null,
  headingText: POLICY_AND_NOTES,
  paymentScheduleHeadingText: PAYMENT_SCHEDULE,
  paymentScheduleRules: null
};
Component.propTypes = process.env.NODE_ENV !== "production" ? {
  cancellationPolicyHeadingText: PropTypes.string,
  cancellationPolicyRules: PropTypes.arrayOf(PropTypes.string),
  damageDepositHeadingText: PropTypes.string,
  damageDepositRules: PropTypes.arrayOf(PropTypes.string),
  extraNotesText: PropTypes.string,
  headingText: PropTypes.string,
  modalTriggerText: PropTypes.string,
  notesHeadingText: PropTypes.string,
  notesText: PropTypes.string,
  paymentScheduleHeadingText: PropTypes.string,
  paymentScheduleRules: PropTypes.arrayOf(PropTypes.string)
} : {};